import { ThemeProvider, createTheme } from '@mui/material/styles'
import { THEME_NAME } from 'utils/helperConfig'
import { createContext, useMemo, useState } from 'react'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const newTheme = require(`./${THEME_NAME}/theme`)
const themeVariables = newTheme?.variables

type ColorMode = 'light' | 'dark'

const CreateTheme = (mode: ColorMode) => {
    // If some WL does not have dark mode, then using light mode as fallback
    const modeVariables = mode === 'dark' && !!themeVariables.palette.dark ? themeVariables.palette.dark : themeVariables.palette.light

    return createTheme({
        ...themeVariables,
        palette: {
            ...themeVariables.palette,
        },
        modeVariables,
    })
}

let theme = CreateTheme('light')

interface IColorModeContext {
    switchColorMode: (newMode?: ColorMode) => void
    mode: 'light' | 'dark'
}
export const ColorModeContext = createContext<IColorModeContext>(undefined)

const MuiThemeProvider: React.FC = ({ children }) => {
    const [mode, setMode] = useState<ColorMode>('light')

    theme = useMemo(() => CreateTheme(mode), [mode])

    const contextValues = useMemo(
        () => ({
            switchColorMode: (newMode?: ColorMode) => {
                setMode(prevMode => newMode || (prevMode === 'light' ? 'dark' : 'light'))
            },
            mode,
        }),
        [mode]
    )
    return (
        <ColorModeContext.Provider value={contextValues}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </ColorModeContext.Provider>
    )
}

export { theme, themeVariables }
export default MuiThemeProvider
